import ApiService from './api-service';

const getNotifications = async ShortCode => {
  const body = {
    query: `
      query($ShortCode: String!) {
        user {
          _id
          totalUnseenNotifications(ShortCode: $ShortCode)
          notifications (ShortCode: $ShortCode) {
            created_at
            _id
            type
            organisation
            seen
            metadata {
              contact { 
                _id
                Name
                ContactID
                collectionDetails {
                  notes
                  options {
                    latePaymentFees
                  }
                }
              }
              author {
                _id
                profile {
                  firstName
                  lastName
                }
              }
              isMultiInvoice
              invoice {
                InvoiceID
                InvoiceNumber
                CurrencyCode
              }
              invoices {
                InvoiceID
                InvoiceNumber
                CurrencyCode
                _id
                DueDate
                AmountDue
              }
              noteHash
            }
          }
        }
      }
    `,
    variables: {
      ShortCode,
    },
  };

  const { user, error } = await ApiService.meEndpoint().post('/', body);
  if (error) {
    throw new Error('Unable to fetch notifications.');
  }

  return user;
};

const markNotificationAsSeen = async (notificationId, ShortCode) => {
  const body = {
    query: `
      mutation($notificationId: String!) {
        markAsSeen(notificationId: $notificationId) {
          _id
          seen
        }
      }
    `,
    variables: { notificationId },
  };

  await ApiService.orgEndpoint(ShortCode).post('/', body);
};

const markNotificationAsUnseen = async (notificationId, ShortCode) => {
  const body = {
    query: `
      mutation($notificationId: String!) {
        markAsUnseen(notificationId: $notificationId) {
          _id
          seen
        }
      }
    `,
    variables: { notificationId },
  };

  await ApiService.orgEndpoint(ShortCode).post('/', body);
};

const markAllNotificationsAsSeen = async ShortCode => {
  const body = {
    query: `
      mutation {
        markAllNotificationsAsSeen 
      }
    `,
  };

  await ApiService.orgEndpoint(ShortCode).post('/', body);
};

const deleteNotification = async (notificationId, ShortCode) => {
  const body = {
    query: `
      mutation($notificationId: NonEmptyString!) {
        deleteNotification(notificationId: $notificationId)
      }
    `,
    variables: { notificationId },
  };

  await ApiService.orgEndpoint(ShortCode).post('/', body);
};

const sendAdminNotification = async (type, options) => {
  const body = {
    query: `
      mutation($type: String!, $options: CollectionsNotification!) {
        sendAdminNotification(type: $type, options: $options)
      }
    `,
    variables: {
      type,
      options,
    },
  };

  await ApiService.meEndpoint().post('/', body);
};

const NotificationService = {
  getNotifications,
  markNotificationAsSeen,
  markNotificationAsUnseen,
  markAllNotificationsAsSeen,
  deleteNotification,
  sendAdminNotification,
};

export default NotificationService;
